import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "d0da754d-7bfa-4ed4-9b7a-1a9ee748d32b",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-1-item-1.svg` },
  },
  {
    id: "d6038c05-e819-4ca3-8100-f0cb3d301f46",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-1-item-2.svg` },
  },
  {
    id: "49659326-e306-49d0-962a-68b3c792f473",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-1-item-3.svg` },
  },
  {
    id: "488238a5-700e-4260-bde5-b2ba9dcb57f4",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-1-item-4.svg` },
  },
];

export const task: Task = {
  id: "bab7ff1e-a7bd-44b0-8d14-f2d9a3e3f2d5",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
    imageHeight: 170,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["49659326-e306-49d0-962a-68b3c792f473"],
};
